/**
 * Shell-level aliases, expanded before the command table is consulted — the
 * same thing `alias ll='ls -la'` does in `.zshrc`.
 *
 * Lives in its own module so both the command table and the interpreter can
 * read it without importing each other.
 */
export const shellAliases: Record<string, string> = {
  ll: 'ls -la',
  la: 'ls -a',
  '..': 'cd ..',
  '...': 'cd ../..',
  cls: 'clear',
  fetch: 'fastfetch',
  gs: 'git status',
  gl: 'git log',
}

export const aliasTable = (): Record<string, string> => shellAliases

/** Expands a leading alias in a command line, leaving the arguments intact. */
export const applyAlias = (input: string): string => {
  const trimmed = input.trimStart()
  const [head, ...rest] = trimmed.split(/\s+/)
  const alias = shellAliases[head]
  return alias ? [alias, ...rest].join(' ') : trimmed
}
